export default "__VITE_ASSET__BSUtYno2__";